// @ts-nocheck
import { IconPresentationProps } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps, LinkProps } from "@store/MobiusOverrides/Link/Link";
import React, { PropsWithChildren } from "react";
import { FC } from "react";

export interface LinkIconPropsWithoutSrc {
    position?: "left" | "right";
    iconProps?: Omit<IconPresentationProps, "src">;
}
interface Props extends LinkProps {
    iconKey?: string;
    iconPropsWithoutSource?: LinkIconPropsWithoutSrc;
}
const HeaderLinkListItem: FC<PropsWithChildren<Props>> = ({
    iconKey,
    iconPropsWithoutSource,
    children,
    ...otherProps
}) => {
    if (!iconKey) {
        return <Link {...otherProps}>{children}</Link>;
    }
    const iconProps: LinkPresentationProps["icon"] = {
        ...iconPropsWithoutSource,
        iconProps: {
            ...iconPropsWithoutSource?.iconProps,
            src: iconKey,
        },
    };

    return (
        <Link {...otherProps} icon={iconProps}>
            {children}
        </Link>
    );
};

export default HeaderLinkListItem;
